<template>
  <div id="cadastro-container">
    
    <Header/>
    <div style="margin-bottom: 48px;">
      <cadastrosimples @cadastropesquisa="retorno_cadastro" />
    </div>
    <!-- <Modal :nome="nome" :cpf_cnpj="cpf_cnpj" @resposta="respConfirm" /> -->

    <!-- <div class="d-flex align-items-center justify-content-center flex-column cadastro-container">
      <b-alert variant="success" :show="cadastrado_concluido" class="pb-1">
        <h4 class="alert-heading"><font-awesome-icon icon="check" class="mr-2" /> Cadastro realizado com sucesso</h4>
        <p><a @click="$router.push({ name: 'login' })" href="#">Clique aqui para ir à tela de login.</a></p>
      </b-alert>
      <h1>Novo Cadastro</h1>
      <h3>Para ter acesso a protesto, Autorização de Cancelamento (Carta de anuência eletrônica) e outros serviços:</h3>
      <b-card v-if="!cadastrado_concluido" tag="article" class="shadow-sm" deck>
        <div slot="header" class="text-center">
          <div class="steps">
            <div :class="step === 1 ? 'active' : 'past'" class="step shadow-sm">01</div>
            <div :class="{ active: step === 2 }" class="step shadow-sm">02</div>
          </div>
        </div>
        -->

        <!-- MEUS DADOS -->

        <!--
        <div v-if="step === 1">
          <b-row>
            <b-col lg="9" class="container-nome">
              <b-form-group label="Nome completo:" label-for="nome">
                <b-form-input id="nome" v-model="nome" placeholder="Seu nome" trim></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3" class="container-contato">
              <b-form-group label="Contato:" label-for="telefone">
                <the-mask
                  :mask="['(##) ####-####', '(##) #####-####']"
                  id="telefone"
                  v-model="telefone"
                  class="form-control"
                  placeholder="(XX) XXXXX-XXXX"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="4" class="container-cpfcpnj">
              <b-form-group label="CPF/CNPJ:" label-for="cpf_cnpj">
                <the-mask
                  :mask="[maskCPF, maskCNPJ]"
                  id="cpf_cnpj"
                  v-model="cpf_cnpj"
                  class="form-control"
                  @blur.native="userExists"
                  :placeholder="(isCnpj?'12.345.678/0001-91':'123.456.789-01')"
                />
              </b-form-group>
            </b-col>
            <b-col lg="2" class="container-rg">
              <b-form-group :label="!isCnpj ? 'RG:' : 'IE:'" label-for="rg">
                <b-form-input id="rg" v-model="rg" trim :maxlength="!isCnpj ? 10 : 12" placeholder="XX.XXX.XXX-XX"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" v-if="!isCnpj" class="container-orgaoemissor">
              <b-form-group label="Órgão emissor:" label-for="orgao_emissor">
                <b-form-input id="rg_org" v-model="rg_org" trim  maxlength="10" placeholder="SSP"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" v-if="!isCnpj" class="container-uf">
              <b-form-group label="UF:" label-for="UF" class="selectContainer">
                <select class="form-control" id="rg_uf" v-model="rg_uf" required>
                  <option v-for="UF in estados" :value="UF.Sigla" :key="UF.ID" :name="UF.Nome">{{ UF.Sigla }}</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col lg="2"  v-if="!isCnpj" class="container-estadocivil">
              <b-form-group label="Estado civil" label-for="EC" class="selectContainer">
                <select class="form-control" id="estadoCivil" v-model="estadoCivil" required>
                  <option v-for="EC in estado_civil" :value="EC.Nome" :key="EC.ID">{{ EC.Nome }}</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="container-ramoatividade" v-if="isCnpj">
              <b-form-group label="Ramo de Atividade:" label-for="profissao">
                <b-form-input id="profissao" v-model="profissao" trim  maxlength="50"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" v-if="!isCnpj">
              <b-form-group label="Profissão:" label-for="profissao">
                <b-form-input id="profissao" v-model="profissao" trim  maxlength="50"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!isCnpj">
            
          </b-row>
          <hr>
          <b-row>
            <b-col lg="12">
              <h2>Endereço</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" class="container-cep">
              <b-form-group label="CEP:" label-for="cep">
                <the-mask :mask="['#####-###']" id="cep" :state="nameState" v-model="cep" class="form-control"  @keyup.native="checkCEP"  placeholder="00000-000"/>
              </b-form-group>
            </b-col>
            <b-col lg="10" class="container-endereco">
              <b-form-group label="Endereço:" label-for="endereco">
                <b-form-input id="endereco" v-model="endereco" trim @keyup.native="validar"  placeholder="Nome da rua/avenida"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="2" class="container-numero">
              <b-form-group label="Número:" label-for="numero">
                <b-form-input id="numero" v-model="numero" trim @keyup.native="validar" placeholder="Nº"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="2" class="container-complemento">
              <b-form-group label="Complemento:" label-for="complemento">
                <b-form-input id="complemento" v-model="complemento" trim placeholder="Ap nº"></b-form-input>
              </b-form-group>
            </b-col>
            
            <b-col lg="4" class="container-bairro">
              <b-form-group label="Bairro:" label-for="bairro" @keyup.native="validar">
                <b-form-input id="bairro" v-model="bairro" trim  placeholder="Tijuca"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="container-cidade">
              <b-form-group label="Cidade:" label-for="cidade">
                <b-form-input id="cidade" v-model="cidade" trim  placeholder="Rio de Janeiro"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="erroCep">
          <b-col cols="12" md="12">
            <div>
              <b-alert show variant="danger" class="text-center">Dados do CEP não localizado</b-alert>
            </div>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col lg="12">
            <h2>Dados de acesso</h2>
          </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
              <b-form-group label="E-mail:" label-for="email">
                <b-form-input id="email" v-model="email" type="email" trim @blur.native="emailExists" placeholder="email@exemplo.com.br" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-invalid-feedback id="input-live-feedback">
                E-mails não conferem.
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Confirme o e-mail:" label-for="email_confirmacao">
                <b-form-input id="email_confirmacao" v-model="email_confirmacao" type="email" trim @keyup.native="validar" placeholder="email@exemplo.com.br"></b-form-input>
              </b-form-group>
            </b-col>
        </b-row>          
        <b-row>
          <b-col lg="6">
            <b-form-group label="Senha:" label-for="senha">
              <b-form-input id="senha" type="password" aria-describedby="input-live-feedback" v-model="senha" @blur.native="validaPass" placeholder="********" autocomplete="off" ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                Senhas não conferem.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col lg="6">
            <b-form-group label="Confirme a senha:" label-for="confirme_senha">
              <b-form-input id="confirme_senha" type="password" v-model="confirme_senha" @keyup.native="validar"  placeholder="********"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        </div>
        -->
        
        <!-- MEU ENDEREÇO -->
        
        <!--
        <div v-if="step === 2">
          <b-row>
            <b-col lg="12">
              <h2>Dados da Quitação</h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Nome completo:" label-for="email">
                <b-form-input id="nome_quitacao" v-model="nome" trim placeholder="Seu nome"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>          
          <b-row>
            <b-col lg="4" class="container-cpfcpnj">
              <b-form-group label="CPF/CNPJ:" label-for="cpf_cnpj_quitacao">
                <the-mask
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                  id="cpf_cnpj"
                  v-model="cpf_cnpj"
                  class="form-control"
                  @blur.native="userExists"
                  :placeholder="(isCnpj?'12.345.678/0001-91':'123.456.789-01')"
                />
              </b-form-group>
            </b-col>
            <b-col lg="8" class="container-banco">
              <b-form-group label="Banco:" label-for="banco_quitacao" class="selectContainerBanco">
                <select class="form-control" id="banco_quitacao" v-model="banco_quitacao_selecionado" required>
                  <option v-for="banco in banco_quitacao" :value="banco.id" :key="banco.id" :name="banco.nome">{{ banco.nome }}</option>
                </select>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="container-tipoconta">
              <b-form-group label="Tipo de conta" label-for="conta_tipo">
                <b-form-radio-group
                  id="conta_tipo"
                  v-model="conta_tipo"
                  name="conta_tipo"
                  >
                  <b-form-radio id="corrente" value="c" class="mr-4">Corrente</b-form-radio>
                  <b-form-radio id="poupanca" value="p">Poupança</b-form-radio>
              </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="container-agencia">
              <b-form-group label="Agência:" label-for="agencia">
                <b-form-input class="agconta" id="agencia" type="text" v-model="agencia" ></b-form-input> <span class="traco">__</span> 
                <b-form-input class="digito" id="agencia_digito" type="text" v-model="agencia_digito" ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="container-conta">
              <b-form-group label="Conta:" label-for="conta">
                <b-form-input class="agconta" id="conta" type="text" v-model="conta" ></b-form-input> <span class="traco">__</span>
                <b-form-input class="digito" id="conta_digito" type="text" v-model="conta_digito" ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col >
              <b-form-group>
                <b-form-checkbox-group
                  id="infoTitulo"
                  v-model="infoTitulo"
                  :options="infoTitulos"
                  name="infoTitulo"
                  stacked
                  :checked="infoTitulo.indexOf(infoTitulos.value) >= 0"
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox-group
                  id="termoAdesao"
                  v-model="termoAdesao"
                  :options="termoAdesoes"
                  name="termoAdesao"
                  stacked
                  @change="exibeTermoAdesao"
                  :checked="termoAdesao.indexOf(infoTitulos.value) >= 0"
                  :state="termoAdesaoAceito"
                ></b-form-checkbox-group>
                <b-form-invalid-feedback :state="termoAdesaoAceito">
                  É necessário aceitar o termo de adesão.
                </b-form-invalid-feedback>
              </b-form-group>          
            </b-col>
          </b-row>
        </div>
        -->


        <!-- DADOS DE ACESSO -->
        <!-- 
          <div v-if="step === 3"></div> 
        -->


        <!-- 

        <b-alert :show="alertUserExists" fade variant="danger" class="text-center">Usuário já cadastrado com o documento informado!</b-alert>
        <b-alert :show="alertPassBasic" fade variant="danger" class="text-center">A senha deve conter ao menos 8 caracteres, <br/> uma maiúscula, uma minúscula, <br/> um caracter especial e um número.</b-alert>
        <b-alert :show="alertEmailExists" fade variant="danger" class="text-center">Já encontra-se usuário cadastrado com o e-mail informado!</b-alert>

        <vue-recaptcha
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          size="invisible"
          :sitekey="sitekey">
        </vue-recaptcha>

        <b-button v-if="step !== 1" id="btn-voltar"  @click="voltar()" variant="danger" class="btn-lg float-left" block><b-spinner id="loading-cadastrar" small type="grow" v-if="loading"></b-spinner> {{ btn_voltar }}</b-button>
        <b-button id="btn-continuar"  @click="continuar()" variant="primary" class="btn-lg float-right" block v-if="!alertUserExists && !alertEmailExists && !alertDocInvalido"><b-spinner id="loading-cadastrar" small type="grow" v-if="loading"></b-spinner> {{ btn_continuar }}</b-button>
      </b-card>
    </div> -->
    
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
// import axios from "axios"
// import { TheMask } from "vue-the-mask"
// import LeftPanel from "../views/Login/LeftPanel.vue"

// import Serv from '../services'
// import Estados from "../services/estados"
// import EstadoCivil from "../services/estado_civil"

// import API from '../services/api'
// import VueRecaptcha from 'vue-recaptcha'
// import Modal from "../components/modal/termoAceite";


import cadastrosimples from "../components/cadastro/simples";

import Header from '../components/Header'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";


export default {
  props: ['tipo_cadastro'],
  components: {
    // LeftPanel,
    // VueRecaptcha,
    // TheMask,
    // Modal,
    cadastrosimples,
    Header,
    footersite,
    footersitemobile
  },
  // computed:{
  //   nameState() {
  //     return this.cep.length > 8 ? true : false
  //   }
  // },
  methods: {
    retorno_cadastro(res){
        if(res.resposta){
            this.$router.push({name: 'painel'});
        }
    },
    // async getBancos() {
    //   const resBancos = await API.get(
    //     `usuario/dadosbancarios/bancos/cadastro`
    //   );
    //   this.banco_quitacao = resBancos.data;
    //   //this.banco_quitacao_selecionado = resBancos.data[0].id
    // },
    // onVerify: function (response) {
    //   let bt = document.getElementById('btn-continuar')
    //   this.tok = response
    //   this.$refs.invisibleRecaptcha.reset()
    //   if(response != ''){
    //     this.loading = true
    //     bt.disabled = true
    //     var select = document.getElementById('banco_quitacao');
    //     var texto = select.options[select.selectedIndex].text;
    //     this.ds_banco = texto
    //     const { nome, email, cpf_cnpj, endereco, numero, complemento,
    //             bairro, codibge, cep, cidade, uf, telefone, celular, infoTitulo, senha, rg, rg_org, rg_uf, profissao, estadoCivil, 
    //             banco_quitacao_selecionado, ds_banco, conta_tipo, agencia, agencia_digito, conta, conta_digito, tok } = this.$data

    //     const dados = { nome, email, cpf_cnpj, endereco, numero, complemento,
    //                     bairro, codibge, cep, cidade, uf, telefone, celular, senha, infoTitulo, rg, rg_org, rg_uf, profissao, estadoCivil, 
    //                     banco_quitacao_selecionado, ds_banco, conta_tipo, agencia, agencia_digito, conta, conta_digito, tok }

    //     let self = this
    //     this.verificarCheckBox();

    //     // cadastra dados do usuário
    //     API.post('usuario', dados).then((res) => {
    //       this.loading = false

    //       if(res.data.cadastrado === true) {

    //         self.cadastrado_concluido = true

    //       }
    //     })
    //   }
    //   this.resetRecaptcha()
    // },
    // resetRecaptcha () {
    //   this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    // },
    // onExpired: function () {
    //   this.$refs.invisibleRecaptcha.reset()
    // },
    // cadastrar() {
    //   this.$refs.invisibleRecaptcha.execute()
    // },
    // verificarCheckBox() {
    //   var infoTitulo = document.getElementsByName("infoTitulo");

    //   for (var i = 0; i < infoTitulo.length; i++) {
    //     if (infoTitulo[i].checked == true) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   }
    // },
    // voltar() {
    //   this.step = this.step - 1
    // },
    // continuar() {
    //   if(this.validar()) {
    //     // documento
    //     if(this.step === 1){
    //       if(!this.validDoc()) {
    //         document.getElementById('cpf_cnpj').classList.add("is-invalid")
    //         return
    //       }
    //       if(!this.validCep()) {
    //         document.getElementById('cep').classList.add("is-invalid")
    //         return
    //       }
    //       if(!Serv.validarEmail(this.email)) {
    //         document.getElementById('email').classList.add("is-invalid")
    //         return
    //       }
    //       if(this.email != this.email_confirmacao){
    //         document.getElementById('email_confirmacao').classList.add("is-invalid")
    //         return
    //       }
    //       if(this.alertEmailExists){
    //         document.getElementById('email').classList.add("is-invalid")
    //         return
    //       }
    //       if(this.senha !== this.confirme_senha) {
    //         document.getElementById('senha').classList.add("is-invalid")
    //         document.getElementById('confirme_senha').classList.add("is-invalid")
    //         return
    //       }
    //       if(this.email !== this.email_confirmacao) {
    //         document.getElementById('email').classList.add("is-invalid")
    //         document.getElementById('email_confirmacao').classList.add("is-invalid")
    //         return
    //       }
    //     }
        
    //     if(this.step === 2) {
    //       if(this.termoAdesaoAceito == null) {
    //        this.termoAdesaoAceito = false
    //        return
    //      }

    //       this.cadastrar()
    //       return
    //     }

    //     // pŕoxima etapa
    //     this.step++
    //     if(this.step === 2) this.btn_continuar = 'Cadastrar' 
    //     // eslint-disable-next-line
    //     return disabled
    //   }
    // },
    // validar() {
    //   let self = this
    //   let erros = 0
    //   let campos = []
    //   if (this.step === 1) {
    //     if(this.isInvalid('telefone', this.telefone)){
    //       campos = ['nome', 'cpf_cnpj', 'rg', 'rg_org', 'rg_uf', 'cep', 'endereco', 'numero', 'bairro', 'cidade', 'email','email_confirmacao', 'senha', 'confirme_senha', 'telefone',]
    //     } else {
    //       campos = ['nome', 'cpf_cnpj', 'rg', 'rg_org', 'rg_uf', 'cep', 'endereco', 'numero', 'bairro', 'cidade', 'email','email_confirmacao', 'senha', 'confirme_senha',]
    //     }
    //   } else if(this.step === 2) {
    //     campos = ['nome_quitacao', 'cpf_cnpj', 'banco_quitacao', 'agencia', 'conta', 'conta_digito']
    //   } else {
    //     campos = ['email','email_confirmacao', 'senha', 'confirme_senha', 'infoTitulo']
    //   }

    //   if(this.cpf_cnpj.length == 14 && this.step === 1) {
    //     campos.splice(2,5)
    //     document.getElementById('rg').classList.remove("is-invalid")
    //     // document.getElementById('profissao').classList.remove("is-invalid")
    //   }
    //   //console.log(this.cpf_cnpj.length)
    //   // verifica campos
    //   campos.forEach((campo) => {
    //     erros += self.isInvalid(campo, self[campo]) ? 1 : 0
    //   })

    //   if(!this.termoAdesaoAceito && this.step === 2) {
    //     this.termoAdesaoAceito = false
    //     erros = 1
    //   }

    //   return erros > 0 ? false : true
    // },
    // isInvalid(field, value) {
    //   if(field == 'banco_quitacao'){
    //     if (this.banco_quitacao_selecionado == '') {
    //       document.getElementById(field).classList.add("is-invalid")
    //     }
    //   }else if(field == 'nome_quitacao'){
    //     if (this.nome == '') {
    //       document.getElementById(field).classList.add("is-invalid")
    //     } else {
    //       document.getElementById(field).classList.remove("is-invalid")
    //     }
    //     value = this.nome
    //   }else if ((!value) || (value == 'undefined')) {
    //     document.getElementById(field).classList.add("is-invalid")
    //   }else{
    //     document.getElementById(field).classList.remove("is-invalid")
    //   }
    //   return value ? false : true;
    // },
    // validDoc() {
    //   let len = this.cpf_cnpj.length, doc = this.cpf_cnpj
    //   return len === 11 && Serv.validarCPF(doc) ? 1 : len === 14 && Serv.validarCNPJ(doc) ? 1 : 0
    // },
    // validCep() {
    //   // eslint-disable-next-line
    //   let len = this.cep.length, doc = this.cep
    //   return len === 8
    // },
    // validaPass(){
    //   let self = this
    //   let bt = document.getElementById('btn-continuar')
    //   // eslint-disable-next-line
    //   const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@()$%^&*=_{}[\]:;\"'|\\<>,.\/~`±§+-]).{8,30}$/;
    //   const str = this.senha;
    //   // eslint-disable-next-line
    //   let m;

    //   if ((m = regex.exec(str)) !== null) {
    //     self.alertPassBasic = false
    //     bt.disabled = false
    //     /*m.forEach((match, groupIndex) => {
    //         console.log(`Found match, group ${groupIndex}: ${match}`);
    //     }); */       
    //   }  else {
    //     self.alertPassBasic = true
    //     bt.disabled = true        
    //   }   
    // },
    // userExists() {
    //   if(this.cpf_cnpj !== null && this.cpf_cnpj !== ''){
    //     let self = this
    //     let bt = document.getElementById('btn-continuar')
    //     API.get(`usuario/doc/${this.cpf_cnpj}`).then((res) => {
    //       if(res.data.exists === true) {
    //         self.alertUserExists = true
    //         bt.disabled = true
    //       } else {
    //         self.alertUserExists = false
    //         bt.disabled = false
    //       }
    //     })
    //   }
    // },
    // emailExists() {
    //   let self = this
    //   let bt = document.getElementById('btn-continuar')
    //   const dados = { email: this.email };
    //   if (this.email){       
    //     API.post(`usuario/email`,dados).then((res) => {
    //       if(res.data.exists === true) {
    //         self.alertEmailExists = true
    //         bt.disabled = true
    //         document.getElementById('email').classList.add("is-invalid")
    //       } else {
    //         self.alertEmailExists = false
    //         bt.disabled = false
    //         document.getElementById('email').classList.remove("is-invalid")
    //       }
    //       return res.data.exists;
    //     })
    //   }
    // },
    // checkCEP(event) {
    //   let len = event.target.value.length
    //   if(len === 9) this.buscar_cep()
    // },
    // buscar_cep() {
    //   let self = this
    //   axios.get(`https://viacep.com.br/ws/${this.cep}/json/`).then(resp => {
    //     if (resp.data.erro == true) {
    //       this.message = "Cep não encontrado."

    //       this.erroCep = true;
    //     } else {
    //       this.erroCep = false;
    //       let dados = resp.data
    //       self.endereco = dados.logradouro
    //       self.bairro = dados.bairro
    //       self.cidade = dados.localidade
    //       self.codibge = dados.ibge
    //       self.uf = dados.uf
    //       self.validar()
    //     }
    //   }).catch(() => {
    //     this.data = null
    //   })
    // },
    // exibeTermoAdesao(){
    //   this.$bvModal.show("modal-conf");
    // },
    // respConfirm(res){
    //   if (res.respostaFinal == "s") 
    //   {
    //       this.termoAdesaoAceito = true
    //       this.continuar()
    //       this.$bvModal.hide("modal-conf");
    //   }
    //   else 
    //   {
    //     this.termoAdesaoAceito = false;
    //     this.$bvModal.hide("modal-conf");
    //     this.showMsgErro();
    //   }
    // },
    // showMsgErro() {
    //     this.boxTwo = ''
    //     this.$bvModal.msgBoxOk('Para prosseguir, deve ser aceito as condições do Termo de Aceite', {
    //       title: 'Atenção',
    //       size: 'sm',
    //       buttonSize: 'sm',
    //       okVariant: 'danger',
    //       headerClass: 'p-2 ',
    //       footerClass: 'p-2 ',
    //       centered: true
    //     })
    //       .then(value => {
    //         this.boxTwo = value
    //       })
    //       .catch(() => {
    //         // An error occurred
    //       })
    //   },
  },
  // data() {
  //   return {
  //     conta_tipo: 'c',
  //     banco_quitacao:[],
  //     ds_banco: '',
  //     agencia: '',
  //     agencia_digito: '',
  //     conta: '',
  //     conta_digito: '',
  //     banco_quitacao_selecionado:'',
  //     maskCPF: '###.###.###-##',
  //     maskCNPJ: '##.###.###/####-##',
  //     disabled: false,
  //     erroCep: false,
  //     sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
  //     loading: false,
  //     cadastrado_concluido: false,
  //     btn_continuar: 'Próximo',
  //     btn_voltar: 'Voltar',
  //     estados: [],
  //     estado_civil: [],
  //     termoAdesaoAceito:null,
  //     titulo: {
  //       1: "Meus dados",
  //       2: "Meu endereço",
  //       3: "Dados de acesso"
  //     },
  //     step: 1,
  //     nome: "",
  //     cpf_cnpj: "",
  //     telefone: "",
  //     celular: "",
  //     assunto: 0,
  //     assuntos: [
  //       { value: 0, text: "Selecione" },
  //       { value: 1, text: "Solteiro" },
  //       { value: 2, text: "Casado" },
  //       { value: 3, text: "Separado" },
  //       { value: 4, text: "Divorciado" },
  //       { value: 5, text: "Viúvo" }
  //     ],
  //     infoTitulo: [],
  //     infoTitulos: [
  //       { value: 0, text: "Aceito receber informações por Email" }
  //     ],
  //     termoAdesao:[],
  //     termoAdesoes:[{ value: 0, text: "Termo de adesao" }],
  //     cep: "",
  //     endereco: "",
  //     numero: "",
  //     complemento: "",
  //     bairro: "",
  //     cidade: "",
  //     codibge: 0,
  //     uf: "",
  //     email: "",
  //     email_confirmacao: "",
  //     senha: "",
  //     confirme_senha: "",
  //     alertUserExists: false,
  //     alertPassBasic: false,
  //     alertEmailExists: false,
  //     rg: '',
  //     rg_org: '',
  //     rg_uf: '',
  //     profissao: '',
  //     estadoCivil: '',
  //     tok: '',
  //     isCnpj:''
  //   }
  // },
  // mounted() {
  //   this.estados = Estados
  //   this.estado_civil = EstadoCivil
  //   this.getBancos()
  // },
  // watch: {
  //   cpf_cnpj(value){
  //     let removeFormatacao = value.replace(["-",".","/"], "")
  //     if(removeFormatacao.length==14)this.isCnpj = true
  //     if(removeFormatacao.length==11)this.isCnpj = false
  //   }
  // }
}
</script>

<style scoped>
.traco{
  margin-left: 8px;
  color: #c6c0c0;
}
.agconta {
  max-width: 60%;
  float: left;
}
.digito {
  max-width: 30%;
  float: right;
}
.steps {
  display: flex;
  width: auto;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.steps > div.step {
  display: inline-block;
  width: 41px;
  height: 41px;
  text-align: center;
  border-radius: 50px;
  background: #A8A8A8 0% 0% no-repeat padding-box;
  font: normal normal bold 15px/20px 'Kanit' !important;
  letter-spacing: 0px;
  padding: 10px 0px;
  color: #FFFFFF;
  text-align: center;
}
.steps > div.step.active {
  color: #fff;
  background: #4780F1 0% 0% no-repeat padding-box;
}
.steps > div.step.past {
  background: #597EB5 0% 0% no-repeat padding-box;  
}
.steps > div.step:not(:last-child){
  margin-right: 62px;
}
.steps > div.step.past:not(:last-child)::after {
  background-color: #597EB5;
}
.steps > div.step:not(:last-child)::after {
  content: '';
  width: 62px;
  height: 1px;
  background-color: #A8A8A8;
  display: flex;
  bottom: 10.5px;
  position: relative;
  left: 41px;
}

.logo {
  cursor: pointer;
  margin-bottom: 30px;
  height: 70px;
}
#cadastro-container {
  width: auto;
  height: fit-content;
  margin-top: 120px;
  padding-top: 19px;
  margin-bottom: 37px;
  padding-bottom: 100px;
}
#cadastro-container .card{
  box-shadow: none !important;
  background-color: unset;
  border: unset;
  border-radius: unset;
  width: inherit;
}
#cadastro-container .card .card-body{
  padding: 0;
  width: inherit;
}
#cadastro-container .card .card-header{
  padding: 0;
  margin-bottom: 40px;
  background-color: white;
  border-bottom: unset;
}
#cadastro-container hr{
  margin-top: 12px;
  margin-bottom: 19px;
  margin-left: -12px;
  width: calc(100% - 12px);
  border-top: 1px solid #F1F1F1;    
}
#cadastro-container h1{
  text-align: center;
  font: normal normal bold 25px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  margin-bottom: 18px;
}
#cadastro-container h2{
  text-align: left;
  font: normal normal bold 25px/34px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
}
#cadastro-container h3{
  text-align: center;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  margin-bottom: 50px;
}
#cadastro-container .card div.selectContainer::after{
  content: '';
  width: 0px;
  height: 0px;
  background: #597EB5 0% 0% no-repeat padding-box;
  z-index: 100;
  display: flex;
  position: relative;
  left: 70%;
  bottom: calc((35px)/2 + 3px);
  border-top: 5px solid #597EB5;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
#cadastro-container .card .container-estadocivil div.selectContainer::after{left: 87%;}

.alert.text-center.alert-danger {
    font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
    letter-spacing: 0px;
}
#cadastro-container .card button#btn-voltar,
#cadastro-container .card button#btn-continuar{
  width: 150px !important;
  height: 42px !important;
  background: #597EB5 0% 0% no-repeat padding-box !important;
  border: 3px solid #597EB5 !important;
  border-radius: 5px !important;
  padding: 0 !important;
  text-align: center;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  margin-right: 22px;
  margin-top: calc(35px - 17px);

}
#cadastro-container .card button#btn-voltar{
  background: #dc3545 0% 0% no-repeat padding-box !important;
  border: 3px solid #dc3545 !important;
}
#cadastro-container .card select::-webkit-scrollbar{width: 5px;}
#cadastro-container .card select::-webkit-scrollbar-track{background-color: #F1F1F1;}
#cadastro-container .card select::-webkit-scrollbar-thumb{background-color: #A8A8A8;}
#cadastro-container .card select::-webkit-scrollbar-thumb:hover{background-color: #8c8c8c;}
#cadastro-container .card option:focus,
#cadastro-container .card option:hover{
  background-color: #8c8c8c;

}
#cadastro-container .card select {
	appearance: none;
  border-radius: 0;
}
#cadastro-container .card select::placeholder,
#cadastro-container .card input::placeholder{
  color: #A8A8A8;
}
#cadastro-container .card select:focus,
#cadastro-container .card input:focus{
  box-shadow: none;
}
#cadastro-container .card .is-invalid{
  border-color: #dc3545;
}
#cadastro-container .card select,
#cadastro-container .card input{
  background: #F1F1F1 0% 0% no-repeat padding-box;
  border: 1px solid #FFFFFF;
  border-radius: 5px;
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
  letter-spacing: 0px;
}
#cadastro-container .card .form-group{
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
  letter-spacing: 0px !important;
  color: #597EB5 !important;
  margin-bottom: 17px;
}

#cadastro-container .left-panel {
  position: absolute;
  left: 0%;
  width: 43%;
  height: 100%;
  background-color:  #004E86 !important;
}
#cadastro-container .left-panel .wrapper {
  padding-right: 200px;
  height: 450px;
  width: 100%;
}
#cadastro-container .left-panel .wrapper h2 {
  padding-top: 25px;
  padding-bottom: 40px;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
#cadastro-container .right-panel {
  position: absolute;
  right: 0%;
  width: 57%;
  height: 100%;
}

#loading-cadastrar {
  vertical-align: 0;
  margin-left: -21px;
}
#cadastro-container .card .col-lg-2.container-cep{
  flex: 0 0 21.3%;
  max-width: 21.3%;
}
#cadastro-container .card .col-lg-10.container-endereco{
  flex: 0 0 78.7%;
  max-width: 78.7%;
}
#cadastro-container .card .col-lg-2.container-numero{
  flex: 0 0 15.5%;
  max-width: 15.5%;
}
#cadastro-container .card .col-lg-2.container-complemento{
  flex: 0 0 21.4%;
  max-width: 21.4%;
}
#cadastro-container .card .col-lg-4.container-bairro{
  flex: 0 0 29.9%;
  max-width: 29.9%;
}
#cadastro-container .card .col-lg-4.container-cidade{
  flex: 0 0 33.2%;
  max-width: 33.2%;
}

#cadastro-container .card .col-lg-9.container-nome{
  flex: 0 0 80%;
  max-width: 80%;
}
#cadastro-container .card .col-lg-3.container-contato{
  flex: 0 0 20%;
  max-width: 20%;
}

#cadastro-container .card .col-lg-4.container-cpfcpnj{
  flex: 0 0 30%;
  max-width: 30%;
}
#cadastro-container .card .col-lg-2.container-rg{
  flex: 0 0 22%;
  max-width: 22%;
}
#cadastro-container .card .col-lg-2.container-orgaoemissor{
  flex: 0 0 15%;
  max-width: 15%;
}
#cadastro-container .card .col-lg-2.container-uf{
  flex: 0 0 11%;
  max-width: 11%;
}
#cadastro-container .card .col-lg-2.container-estadocivil{
  flex: 0 0 22%;
  max-width: 22%;
}
#cadastro-container .card .col-lg-6.container-ramoatividade{
  flex: 0 0 48%;
  max-width: 48%;
}
#cadastro-container .card .col-lg-8.container-banco{
  flex: 0 0 70%;
  max-width: 70%;
}
#cadastro-container .card .col-lg-4.container-tipoconta{
  flex: 0 0 30%;
  max-width: 30%;
}
#cadastro-container .card .col-lg-4.container-agencia,
#cadastro-container .card .col-lg-4.container-conta{
  flex: 0 0 35%;
  max-width: 35%;
}



#cadastro-container .card .col-lg-1,
#cadastro-container .card .col-lg-2,
#cadastro-container .card .col-lg-3,
#cadastro-container .card .col-lg-4,
#cadastro-container .card .col-lg-5,
#cadastro-container .card .col-lg-6,
#cadastro-container .card .col-lg-7,
#cadastro-container .card .col-lg-8,
#cadastro-container .card .col-lg-9,
#cadastro-container .card .col-lg-10,
#cadastro-container .card .col-lg-11,
#cadastro-container .card .col-lg-12{
  padding-right: 36px;
  padding-left: 0;
}
.cadastro-container{
  width: calc(964px + 6px);
    padding-left: calc(12px + 46px);
  margin: 0 auto;
}

@media (max-width: 1200px) {
  #cadastro-container {
    margin-top: 68px;
    margin-bottom: 0px;
    padding-bottom: 0px;
  }
}

</style>
